import { Card, Stack, Typography, Box } from "@mui/joy";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import ArticleRoundedIcon from "@mui/icons-material/ArticleRounded";

interface QuestionPaperCardProps {
  exam: any;
}

export default function QuestionPaperCard({ exam }: QuestionPaperCardProps) {
  // if (!exam.questionPaperArtifactUri) return null;

  return (
    <Card
      sx={{
        position: "relative",
        background: "#E0F7FA",
        flex: 1,
        border: "none",
        overflow: "hidden",
        transition: "background-color 0.2s ease, transform 0.2s ease",
        mb: { xs: 2, sm: 0 },
        ...(exam.status == "standby-locked" || exam.status == "standby-open"
          ? {}
          : {
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#B2EBF2",
                transform: "scale(1.02)",
              },
            }),
      }}
      onClick={() => {
        if (exam.status != "standby-locked" && exam.questionPaperArtifactUri) {
          window.open(exam.questionPaperArtifactUri, "_blank");
        }
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography
          level="title-lg"
          sx={{ mb: 2, color: "#006064" }}
        >
          Question Paper
        </Typography>
        <NorthEastIcon
          sx={{ mb: 2, color: "#006064", fontSize: 20 }}
        />
      </Stack>
      <Box
        sx={{
          position: "absolute",
          bottom: "8%",
          right: "8%",
          opacity: 0.15,
          transform: "scale(2.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ArticleRoundedIcon sx={{ fontSize: 40 }} />
      </Box>
    </Card>
  );
}
